import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicProfile } from '../utils/profileApi';

export default function UserProfile() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchUser() {
      try {
        const data = await getPublicProfile(id);
        setUser(data);
      } catch (err) {
        setError('Utilisateur non trouvé');
      }
      setLoading(false);
    }
    fetchUser();
  }, [id]);

  if (loading) return <div>Chargement...</div>;
  if (error) return <div>{error}</div>;
  if (!user) return <div>Utilisateur non trouvé</div>;

  return (
    <div className="container">
      <h2>Profil de {user.displayName}</h2>
      {user.photoURL && <img src={user.photoURL} alt="Photo" style={{width:'100px', height:'100px', borderRadius:'50%'}} />}
      <p><strong>Nom :</strong> {user.firstName} {user.lastName}</p>
      <p><strong>Pseudo :</strong> {user.displayName}</p>
      <p><strong>Email :</strong> {user.email}</p>
      <p><strong>Pays :</strong> {user.country}</p>
      <p><strong>Téléphone :</strong> {user.phone}</p>
      <p><strong>Genre :</strong> {user.gender}</p>
      <p><strong>Date de naissance :</strong> {user.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : ''}</p>
    </div>
  );
}